import script from "./PaymentStep.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStep.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStep.vue?vue&type=style&index=0&id=1b8807c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b8807c0"]])

export default __exports__